import { fyQuarterHeaders, tableHeaders } from "../constants";
import { BreakdownTable } from "./BreakdownTable";
import { ChartsGrid } from "./ChartsGrid";
import { EmptyState } from "./EmptyState";
import { PeriodBreakdownTable } from "./PeriodBreakdownTable";
import { StateCompanyBreakdownTable } from "./StateCompanyBreakdownTable";
import { StatusBreakdownTable } from "./StatusBreakdownTable";
import { SurchargeTable } from "./SurchargeTable";
import { SurchargeTrendsGrid } from "./SurchargeTrendsGrid";

export function DashboardTabContent({
  activeTab,
  tableData,
  tableLoading,
  surchargeTrends,
  isTrendsLoading,
  charts,
  isChartsLoading,
  visibleTables,
}) {
  return (
    <div className="mt-6 space-y-7">
      {activeTab === "summary" ? (
        <StatusBreakdownTable rows={tableData.byStatus} isLoading={tableLoading} />
      ) : null}
      {activeTab === "surcharges" ? (
        <>
          <SurchargeTable rows={tableData.top10Surcharges} isLoading={tableLoading} />
          <SurchargeTrendsGrid data={surchargeTrends} isLoading={isTrendsLoading} />
        </>
      ) : null}
      {activeTab === "trends" ? (
        <ChartsGrid charts={charts} isLoading={isChartsLoading} />
      ) : null}
      {visibleTables.length ? (
        visibleTables.map((config) => (
          config.key === "byFyMonth" || config.key === "byFyQuarter" ? (
            <PeriodBreakdownTable
              key={config.key}
              title={config.title}
              icon={config.icon}
              rulesKey={config.rulesKey || config.key}
              dimensionColumns={config.dimensionColumns}
              rows={tableData[config.key]}
              isLoading={tableLoading}
              headers={config.key === "byFyQuarter" ? fyQuarterHeaders : tableHeaders}
            />
          ) : config.key === "byFromStateAndCompany" || config.key === "byToStateAndMetroRegional" ? (
            <StateCompanyBreakdownTable
              key={config.key}
              title={config.title}
              icon={config.icon}
              rulesKey={config.rulesKey || config.key}
              stateColumn={config.dimensionColumns[0]}
              childColumn={config.childColumn}
              childrenKey={config.childrenKey}
              rows={tableData[config.key]}
              isLoading={tableLoading}
            />
          ) : (
            <BreakdownTable
              key={config.key}
              title={config.title}
              icon={config.icon}
              dimensionColumns={config.dimensionColumns}
              rows={
                config.key === "byServiceType"
                  ? tableData.byServiceType.filter((row) => row.serviceType !== "Unmapped")
                  : tableData[config.key]
              }
              isLoading={tableLoading}
              tableKey={config.key}
              rulesKey={config.rulesKey || config.key}
            />
          )
        ))
      ) : (
        activeTab === "surcharges" || activeTab === "trends" ? null : <EmptyState message="This tab does not have a visual section yet." />
      )}
    </div>
  );
}
